import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { SsrsConfigModel } from '../models/SsrsConfigModel';
import { ReportCategoryModel } from '../models/ReportCategoryModel';

@Injectable()
export class ReportService {
  constructor(public httpClient: HttpClient) { }

  getSsrsReportsList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<ReportCategoryModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<ReportCategoryModel>>("/api/ReportModule/Reports/ListQuery", { params: params });
  }

  getSsrsConfig(): Observable<ModelResponse<SsrsConfigModel>> {
    return this.httpClient.get<ModelResponse<SsrsConfigModel>>("/api/ReportModule/GetSsrsConfig/");
  }
}



// WEBPACK FOOTER //
// ./src/app/report/services/ReportService.ts